import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn, FlexRow } from "@similarweb/ui-components";

const { carbon } = colorsPalettes;

export const GreyCaptionText = styled(FlexRow)`
    gap: 4px;
    align-items: center;
    ${setFontVariant("caption", carbon[300])}
`;
export const BodyWrapper = styled(FlexColumn)`
    height: 8px;
`;
